import { Provider } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import Analytics from './analytics/Analytics';
import App from './App';
import SentryErrorBoundary from './components/error/SentryErrorBoundary';
import MaintenanceHandler from './components/maintenance/MaintenanceHandler';
import AnalyticsService from './services/AnalyticsService';
import ApiWrapper from './services/ApiWrapper';
import FormValidator from './services/FormValidator';
import LocationContext from './services/LocationContext';
import RouteService from './services/RouteService';
import RootStore from './store';
import { parse } from './util/queryString';

const initialState = window.__INITIAL_STATE__ || {};
const pageLoadQueryParams = parse(window.location.search);

const apiWrapper = new ApiWrapper(
  process.env.REACT_APP_API_URL || window.location.hostname + '/backend/v1',
  {
    gclid: pageLoadQueryParams.gclid,
    cuad: pageLoadQueryParams.cuad,
  }
);
const locationContext = new LocationContext(
  () => window.location.protocol,
  () => window.location.host,
  () => window.location.href
);

const store = RootStore.create(initialState, {
  apiWrapper,
  locationContext,
});

const routeService = new RouteService(
  store.categoryStore,
  store.configStore,
  store.languageStore,
  store.sectionStore,
);

const formValidator = new FormValidator(store.configStore);

const analytics = new Analytics(
  store.currencyStore,
  store.uiStore,
  store.configStore
);

// This should supercede analytics injection in components in time.
// Currently components include a lot of analytics related logic.
const analyticsService = new AnalyticsService(
  analytics,
  store,
);

class BrowserApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maintenance: {
        active: false,
        message: '',
      },
    };

    apiWrapper.registerMaintenanceCallback(this.setMaintenance);
  }

  setMaintenance = (active, message) => {
    this.setState({ maintenance: { active, message } });
  };

  render() {
    const ErrorBoundaryWrapper =
      process.env.NODE_ENV === 'production' ? SentryErrorBoundary : Fragment;

    return (
      <ErrorBoundaryWrapper>
        <MaintenanceHandler {...this.state.maintenance}>
          <Provider
            {...store}
            routeService={routeService}
            analytics={analytics}
            analyticsService={analyticsService}
            apiWrapper={apiWrapper}
            locationContext={locationContext}
            formValidator={formValidator}
          >
            <BrowserRouter>
              <HelmetProvider>
                <App store={store} />
              </HelmetProvider>
            </BrowserRouter>
          </Provider>
        </MaintenanceHandler>
      </ErrorBoundaryWrapper>
    );
  }
}

export default BrowserApp;
